function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContextMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1432",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-536.423,-548.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ribbon",
    transform: "matrix(1,0,0,1,-0.262805,-237.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ribbon-Border",
    d: "M777.976,1775.02C632.582,1678.31 536.685,1512.98 536.685,1325.43C536.685,1027.63 778.462,785.853 1076.26,785.853C1374.06,785.853 1615.84,1027.63 1615.84,1325.43C1615.84,1512.66 1520.28,1677.74 1375.31,1774.52L1501.35,2113.29C1506.26,2126.49 1497.78,2140.62 1482.42,2144.85L1340.34,2110.68L1248.69,2209.07C1233.32,2213.29 1216.88,2206.01 1211.97,2192.8L1089.95,1864.84C1085.4,1864.95 1080.84,1865.01 1076.26,1865.01C1072.03,1865.01 1067.8,1864.96 1063.59,1864.86L939.279,2199.82C934.366,2213.06 917.926,2220.36 902.559,2216.13L810.904,2117.49L668.83,2151.75C653.463,2147.51 644.989,2133.35 649.903,2120.11L777.976,1775.02Z",
    style: {
      fill: "white",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Inner-Circle",
    cx: 1074.89,
    cy: 1325.52,
    r: 503.155,
    style: {
      fillOpacity: 0.81
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Light-bulb",
    transform: "matrix(1,0,0,1,-3.98474,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Metal-Bottom",
    transform: "matrix(1,0,0,1,1.87829,4.11745e-07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.96,1715C1029.24,1715 1028.56,1715.33 1028.11,1715.91C1027.67,1716.48 1027.51,1717.22 1027.69,1717.92C1030.2,1726.66 1040.51,1752 1076,1752C1113.21,1752 1123.76,1726.67 1126.29,1717.93C1126.47,1717.23 1126.32,1716.49 1125.88,1715.91C1125.44,1715.35 1124.76,1715.01 1124.03,1715.01C1109.36,1715 1044.63,1715 1029.96,1715Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Metal-Top",
    transform: "matrix(0.992443,0,0,0.992443,947.9,1567.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,46.539C34.322,61.091 40.583,75.991 70.385,76.015C88.951,76.03 92.996,76.579 91.569,78.888C91.111,79.63 85.476,80 74.632,80C53.756,80 54.618,79.425 54.476,93.443C54.344,106.45 52.699,105.391 74,106C98.428,106.698 96.449,108.368 70.446,109C49.952,109.498 49.875,109.509 47.963,112C46.005,114.552 45.026,128.401 46.75,129.167C47.163,129.35 48.76,131.188 50.301,133.25C51.841,135.312 53.547,137 54.091,137C54.636,137 56.451,138.012 58.124,139.25C63.926,143.539 202.882,142.623 209.173,138.255C220.328,130.509 223.87,117.088 216.677,109.821C216.58,109.723 207.16,109.386 195.745,109.071C169.725,108.355 167.933,106.703 192.415,106C213.075,105.407 211.042,106.807 211.222,93.052C211.403,79.174 212.685,80.034 191.809,80.015C180.657,80.005 174.89,79.631 174.431,78.888C173.002,76.576 177.06,76.03 195.798,76.015C218.983,75.997 220,75.525 220,64.784C220,56.929 216.633,51.913 207.893,46.75C198.379,41.129 67.103,40.945 58,46.539",
    style: {
      fill: "url(#_Linear2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bulb",
    transform: "matrix(1.10931,0,0,1.0342,-142.811,-33.5445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.719,1236.2C895.719,1116.45 987.865,1019.22 1101.36,1019.22C1214.86,1019.22 1307.01,1116.45 1307.01,1236.2C1307.16,1242.22 1306.87,1248.62 1306.23,1255.26C1304.81,1272.45 1301.48,1289.07 1296.48,1304.88C1288.92,1332.11 1278.83,1357.03 1271.43,1369.76C1227.56,1445.3 1209.5,1491.85 1199.72,1557.47C1198.76,1563.93 1193.56,1568.68 1187.46,1568.66C1153.84,1568.53 1050.34,1568.12 1014.96,1567.94C1008.38,1567.92 1002.98,1562.36 1002.69,1555.32C1001.63,1538 997.882,1519.29 992.877,1499.23C984.358,1465.1 958.924,1420.18 940.628,1383.27C933.119,1368.13 920.338,1344.21 910.3,1316.55C907.74,1309.79 905.494,1302.86 903.58,1295.78C898.156,1276.54 894.771,1256.2 895.719,1236.2Z",
    style: {
      fill: "url(#_Radial3)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Puzzle",
    transform: "matrix(-0.999598,0.028367,-0.028367,-0.999598,1413.99,1590.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.994,159.874C366.898,161.874 362.687,165.102 350.327,177.249C337.154,190.194 337.154,190.194 334.037,183.73C323.235,161.333 300.618,155.658 284.291,171.249C268.836,186.007 274.217,209.836 295.427,220.564C298.687,222.212 301.507,224.02 301.693,224.579C301.88,225.139 284.943,242.712 264.055,263.631C243.168,284.549 225.611,302.894 225.039,304.397C221.217,314.45 226.14,321.148 243.844,329.982C253.889,334.994 257,338.924 257,346.597C257,362.947 238.008,362.879 229.788,346.5C215.172,317.375 210.204,317.391 181.337,346.657C155.099,373.256 154.83,380.054 179.047,404.511C193.838,419.448 193.716,419.168 186.907,422.452C168.116,431.517 160.896,447.505 168.406,463.419C179.739,487.432 211.081,486.686 223.091,462.117C227.654,452.781 226.992,452.593 242.009,467.474C267.243,492.477 273.284,492 302.772,462.676C328.64,436.953 328.292,429.469 300.652,417.068C286.129,410.552 283.216,393.712 295.952,389.896C304.718,387.27 310.966,391.346 317.135,403.718C331.47,432.464 333.802,431.711 383.075,382.425C423.825,341.664 422.479,342.675 425.792,350.332C439.629,382.317 483.466,375.607 483.493,341.5C483.504,327.94 477.921,320.026 463.25,312.803C455.452,308.963 454.825,310.63 469.573,295.985C494.785,270.95 494.546,263.408 467.679,236.255C443.73,212.052 436.64,212.21 424.307,237.223C416.732,252.583 403.368,257.212 396.956,246.696C391.637,237.972 396.261,229.281 409.738,222.671C434.675,210.439 434.975,203.842 411.672,180.233C392.32,160.626 384.019,156.257 372.994,159.874M371,172.469C369.075,173.762 360.981,181.386 353.013,189.41C334.467,208.088 334.225,208.09 325.16,189.708C316.539,172.226 302.957,167.808 291.882,178.882C280.965,189.8 285.154,203.226 302.219,212.004C321.606,221.977 321.782,220.742 297.5,245C274.234,268.243 274.667,263.194 294.261,282.761C312.956,301.43 311.912,300.955 315.998,292.656C326.483,271.359 349.39,265.762 364.489,280.81C381.187,297.451 376.204,319.878 353.25,331.399C346.153,334.961 345.846,334.372 364.501,353.001C381.002,369.479 381.002,369.479 400.751,349.872C425.89,324.913 424.703,325.18 433.519,342.497C442.24,359.627 450.955,364.418 462.554,358.459C480.33,349.326 477.325,332.003 456.07,321.085C447.03,316.441 442,312.382 442,309.729C442,309.179 449.614,301 458.919,291.553C482.957,267.152 482.974,266.864 461.668,245.218C442.055,225.29 442.411,225.333 433.968,241.859C426.063,257.332 419.731,262 406.646,262C378.319,262 376.561,226.545 404.251,213.696C421.462,205.71 421.446,204.884 403.75,187.375C384.424,168.254 380.162,166.314 371,172.469M251.817,290.712C230.815,311.582 230.832,311.462 247.592,319.826C260.955,326.494 266.481,332.819 267.663,342.802C271.367,374.075 234.067,379.337 219.377,349.613C210.766,332.19 210.634,332.195 191.792,350.75C166.538,375.618 166.525,377.298 191.398,401.988C211.615,422.057 211.62,422.419 191.812,431.936C174.568,440.221 170.944,454.842 183.42,465.795C194.229,475.286 206.655,470.56 215.439,453.616C225.082,435.016 224.155,434.945 245.447,455.919C270.284,480.386 269.9,480.384 294.25,456.151C314.818,435.682 314.767,436.303 296.645,427.151C274.465,415.95 270.429,392.038 288.892,381.217C302.512,373.236 318.09,380.858 327.281,400C334.818,415.696 334.613,415.73 355.183,395.288C375.576,375.023 375.935,379.515 352,355.476C341,344.428 332,334.876 332,334.25C332,331.729 337.007,327.736 346.497,322.69C364.49,313.123 368.771,301.782 358.713,290.326C347.132,277.136 333.417,281.466 323.329,301.5C314.574,318.886 315.595,319.119 290.5,294C266.676,270.153 272.045,270.61 251.817,290.712",
    style: {
      fillOpacity: 0.81
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Light-Lines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_90-",
    transform: "matrix(1,0,0,1,-1,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1655.61,176.185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077.47,943.2L1077.47,885.1",
    style: {
      fill: "none",
      stroke: "rgb(255,233,32)",
      strokeWidth: "27.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,2332.44,176.185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077.47,943.2L1077.47,885.1",
    style: {
      fill: "none",
      stroke: "rgb(255,233,32)",
      strokeWidth: "27.85px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_70-",
    transform: "matrix(1,0,0,1,-1.03826,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.367648,0.929965,-0.475494,-0.18798,1610.92,298.737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1091.39,943.2C1091.39,958.229 1085.16,970.431 1077.47,970.431C1069.79,970.431 1063.55,958.229 1063.55,943.2L1063.55,885.1C1063.55,870.071 1069.79,857.869 1077.47,857.869C1085.16,857.869 1091.39,870.071 1091.39,885.1L1091.39,943.2Z",
    style: {
      fill: "rgb(255,233,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.367648,0.929965,0.475494,-0.18798,548.914,298.737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1063.55,943.2C1063.55,958.229 1069.79,970.431 1077.47,970.431C1085.16,970.431 1091.39,958.229 1091.39,943.2L1091.39,885.1C1091.39,870.071 1085.16,857.869 1077.47,857.869C1069.79,857.869 1063.55,870.071 1063.55,885.1L1063.55,943.2Z",
    style: {
      fill: "rgb(255,233,32)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_45-",
    transform: "matrix(1,0,0,1,-0.869211,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707107,-0.707107,0.707107,0.707107,-567.763,1129.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077.47,943.2L1077.47,885.1",
    style: {
      fill: "none",
      stroke: "rgb(255,233,32)",
      strokeWidth: "27.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707107,0.707107,-0.707107,0.707107,1203.48,-394.431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077.47,943.2L1077.47,885.1",
    style: {
      fill: "none",
      stroke: "rgb(255,233,32)",
      strokeWidth: "27.85px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_22-",
    transform: "matrix(1,0,0,1,-0.643697,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.924068,0.382227,-0.195434,-0.472479,2129.89,973.878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1091.39,943.2C1091.39,958.229 1085.16,970.431 1077.47,970.431C1069.79,970.431 1063.55,958.229 1063.55,943.2L1063.55,885.1C1063.55,870.071 1069.79,857.869 1077.47,857.869C1085.16,857.869 1091.39,870.071 1091.39,885.1L1091.39,943.2Z",
    style: {
      fill: "rgb(255,233,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.924068,0.382227,0.195434,-0.472479,29.1564,973.878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1063.55,943.2C1063.55,958.229 1069.79,970.431 1077.47,970.431C1085.16,970.431 1091.39,958.229 1091.39,943.2L1091.39,885.1C1091.39,870.071 1085.16,857.869 1077.47,857.869C1069.79,857.869 1063.55,870.071 1063.55,885.1L1063.55,943.2Z",
    style: {
      fill: "rgb(255,233,32)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "matrix(1,0,0,1,1.40716,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077.47,943.2L1077.47,885.1",
    style: {
      fill: "none",
      stroke: "rgb(255,233,32)",
      strokeWidth: "27.85px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Right-Tail",
    transform: "matrix(1,0,0,1,4,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100.71,1864.27C1195.52,1859.34 1283.88,1829.88 1359.58,1782.13L1477.01,2097.75C1481.46,2109.73 1473.77,2122.55 1459.83,2126.38L1330.91,2095.38L1247.74,2184.66C1233.79,2188.49 1218.87,2181.88 1214.42,2169.9L1100.71,1864.27Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left-Tail",
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.07,1864.33L930.237,2176.43C925.789,2188.41 910.906,2195.02 896.994,2191.19L814.016,2101.89L685.393,2132.9C671.482,2129.07 663.81,2116.25 668.258,2104.26L787.459,1783.08C863.149,1830.48 951.413,1859.62 1046.07,1864.33Z",
    style: {
      fill: "url(#_Linear5)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(100,0,0,100,1027,1733.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(189,189,189)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "rgb(210,210,210)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(216,216,216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "rgb(211,211,211)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(189,189,189)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(176.886,0,0,176.886,43.5322,92.2379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(188,188,188)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "rgb(211,211,211)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(217,217,217)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(211,211,211)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(199,199,199)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(188,188,188)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.2222e-14,-214.097,199.6,1.31097e-14,1100.98,1236.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,239,93)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(286.364,-99.6838,99.6838,286.364,1146.76,2030.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,238,91)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(255,254,251)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,238,91)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(286.249,102.065,-102.065,286.249,668.706,2056.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,238,91)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(255,254,251)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,238,91)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMaster);
export default __webpack_public_path__ + "static/media/ContextMaster.ca7bc493785a47a85e4f0f80a2ad3f79.svg";
export { ForwardRef as ReactComponent };